import React, { useState } from 'react';
import { PasoNombre } from '../components/onboarding/PasoNombre';
import { PasoDireccion } from '../components/onboarding/PasoDireccion';
import { PasoAnticipo } from '../components/onboarding/PasoAnticipo';
import { PasoServicios } from '../components/onboarding/PasoServicios';
import { PasoQuienAtiende } from '../components/onboarding/PasoQuienAtiende';
import { PasoAsignarServicios } from '../components/onboarding/PasoAsignarServicios';
import { PasoSuscripcion } from '../components/onboarding/PasoSuscripcion';
import { PasoListo } from '../components/onboarding/PasoListo';

const PASOS = ['nombre', 'direccion', 'anticipo', 'servicios', 'quien', 'asignar', 'suscripcion', 'listo'];

export const OnboardingRouter = ({ pasoInicial = 'nombre' }) => {
    const [pasoActual, setPasoActual] = useState(pasoInicial);
    const [manejaAnticipo, setManejaAnticipo] = useState(false);

    const siguiente = () => {
        const idx = PASOS.indexOf(pasoActual);
        if (idx < PASOS.length - 1) setPasoActual(PASOS[idx + 1]);
    };

    const anterior = () => {
        const idx = PASOS.indexOf(pasoActual);
        if (idx > 0) setPasoActual(PASOS[idx - 1]);
    };

    const props = { siguiente, anterior, manejaAnticipo, setManejaAnticipo };

    switch (pasoActual) {
        case 'nombre':       return <PasoNombre {...props} />;
        case 'direccion':    return <PasoDireccion {...props} />;
        case 'anticipo':     return <PasoAnticipo {...props} />;
        case 'servicios':    return <PasoServicios {...props} />;
        case 'quien':        return <PasoQuienAtiende {...props} />;
        case 'asignar':      return <PasoAsignarServicios {...props} />;
        case 'suscripcion':  return <PasoSuscripcion {...props} />;
        case 'listo':        return <PasoListo {...props} />;
        default:             return <PasoNombre {...props} />;
    }
};
